document.addEventListener('DOMContentLoaded', function () {
    const descriptions = document.querySelectorAll('.section-hero-collections .description-product');

    // Al iniciar, para cada descripción se guarda la altura colapsada.
    descriptions.forEach(description => {
        // Se guarda la altura inicial solo si la descripción no está expandida.
        if (!description.classList.contains('active')) {
            description.dataset.collapsedHeight = description.offsetHeight;
        }
    });

    function checkOverflow() {
        descriptions.forEach(description => {
            const paragraph = description.querySelector('p');
            const button = description.nextElementSibling;

            if (!paragraph || !button || !button.classList.contains('button-read-more')) return;

            // Se utiliza la altura colapsada previamente guardada.
            const collapsedHeight = parseFloat(description.dataset.collapsedHeight) || description.offsetHeight;

            // Si el contenido total es mayor que la altura colapsada, hay overflow.
            if (paragraph.scrollHeight > collapsedHeight) {
                button.classList.add('active');
            } else {
                button.classList.remove('active');
            }

            // Sólo se añade el listener una vez.
            if (!button.dataset.listenerAttached) {
                button.addEventListener('click', () => {
                    // Alterna la clase "active" en la descripción para expandir/contraer el contenido.
                    description.classList.toggle('active');

                    // Cambia el texto del botón según el estado
                    if (description.classList.contains('active')) {
                        button.textContent = 'Read less';
                    } else {
                        button.textContent = 'Read more';
                    }
                    // NOTA: No modificamos la clase "active" del botón aquí.
                });

                button.dataset.listenerAttached = 'true';
            }
        });
    }

    checkOverflow();

    // Al hacer resize, solo se actualiza la altura colapsada en las descripciones que estén cerradas.
    window.addEventListener('resize', () => {
        descriptions.forEach(description => {
            if (!description.classList.contains('active')) {
                description.dataset.collapsedHeight = description.offsetHeight;
            }
        });
        checkOverflow();
    });

    // Opcional: usar ResizeObserver para adaptarse a cambios en la altura del contenedor
    const resizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
            const description = entry.target;
            if (!description.classList.contains('active')) {
                description.dataset.collapsedHeight = description.offsetHeight;
            }
        });
        checkOverflow();
    });
    descriptions.forEach(desc => resizeObserver.observe(desc));
});
